import {useEffect, useState} from 'react';

/** Секунды → mm:ss для таймера повторной отправки кода. */
export const formatSeconds = (totalSeconds: number): string => {
	const minutes = Math.floor(totalSeconds / 60);
	const seconds = totalSeconds % 60;

	return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

/**
 * Значение с задержкой: меняется, когда пользователь перестал печатать.
 *
 * Портирован из otveto (apps/web/src/utils/common.ts) — там на нём держатся
 * поиск и подсказки. Нужен там, где реакция на каждый символ либо дорога
 * (запрос), либо мешает: ошибка формата, вываленная на второй букве, ругается
 * на ещё недописанное значение.
 */
export function useDebounce<T>(value: T, delay = 500): T {
	const [debounced, setDebounced] = useState<T>(value);

	useEffect(() => {
		const timer = setTimeout(() => setDebounced(value), delay);

		return () => clearTimeout(timer);
	}, [value, delay]);

	return debounced;
}

/**
 * Целая часть введённого: цифры до первого нецифрового символа.
 *
 * Нужна полям, которые целые по смыслу — часы, минуты, километры, люди: нецелое
 * значение до сервера не доезжает вовсе (`toInt`), а у направлений отгрузки состав
 * пересоздаётся целиком, поэтому «12,5» не усекается, а стирает сохранённый
 * норматив. Фильтр на вводе показывает человеку, что принято, сразу.
 *
 * Про склейку честно: она остаётся при посимвольном наборе — запятая не принимается,
 * и следующая цифра встаёт за предыдущей, «8,5» набирается в «85». Отрезание
 * работает на вставке целиком («12,5» → «12»). Полностью это лечится не фильтром,
 * а ошибкой у поля, как у дневной мощности (SKS-335), — здесь таких правил нет.
 */
export const integerPart = (value: string): string => value.trimStart().replace(/\D.*$/, '');
